import React from "react";
import { Link } from "react-router-dom";
import { Lock, Crown } from "lucide-react";

export default function Paywall({ title = "Premium Feature", description = "Upgrade once to unlock the AI Coach and insights forever." }) {
  return (
    <div className="relative">
      <div className="bg-[#111111] text-white p-10 border border-black text-center" data-testid="paywall">
        <Lock size={32} className="mx-auto text-[var(--alert-red)]" />
        <div className="overline text-white/60 mt-3 flex items-center justify-center gap-2">
          <Crown size={12} /> PREMIUM ONLY
        </div>
        <h3 className="font-display font-black text-3xl tracking-tighter mt-2">{title}</h3>
        <p className="font-mono text-sm text-white/70 mt-3 max-w-md mx-auto">{description}</p>
        <div className="mt-5 inline-flex items-center gap-3 border-2 border-[var(--alert-red)] px-4 py-2">
          <span className="font-mono text-sm text-white/50 line-through">₹499</span>
          <span className="font-display font-black text-2xl tracking-tighter">₹200</span>
          <span className="bg-[var(--alert-red)] text-white font-display font-black text-[10px] px-2 py-1 tracking-widest">
            SPECIAL LAUNCH
          </span>
        </div>
        <Link
          to="/upgrade"
          data-testid="paywall-upgrade-link"
          className="mt-4 inline-block bg-[var(--alert-red)] text-white px-8 py-3 font-display font-bold tracking-wider hover:bg-white hover:text-black transition-colors"
        >
          UNLOCK FOR ₹200 →
        </Link>
        <div className="mt-2 font-mono text-[10px] text-white/40">
          One-time payment · Save ₹299 · Lifetime access
        </div>
      </div>
    </div>
  );
}
